module.exports = __webpack_public_path__ + "img/feature_7.42fd9570.svg";